import { BadgeUserAccountStatus } from '@/components/custom';
import { TableCell } from '@/components/ui';
import { IHasUser } from '.';

export const DataTableBodyCellAccountStatus = ({ user }: IHasUser) => (
  <TableCell className='py-1 pe-0 w-0'>
    <BadgeUserAccountStatus
      user={user}
      className='text-nowrap px-2 py-0.5 text-xs rounded-sm' />
  </TableCell>
);

export default DataTableBodyCellAccountStatus;
